import { type TextStyles, textStyles } from './textStyles.js';
import {
  color,
  type ColorProps,
  compose,
  display,
  type DisplayProps,
  type FlexboxProps,
  lineHeight,
  type LineHeightProps,
  space,
  type SpaceProps,
  type LayoutProps as StyledLayoutProps,
  type TextAlignProps as StyledTextAlignProps,
  type TypographyProps as StyledTypographyProps,
  textAlign,
  typography,
  variant,
} from 'styled-system';

const textStyle = variant({
  prop: 'textStyle',
  scale: 'textStyles',
  variants: textStyles,
});

export type CommonProps = ColorProps &
  DisplayProps &
  LineHeightProps &
  SpaceProps &
  StyledTextAlignProps;
export const COMMON = compose(space, color, display, lineHeight, textAlign);

export type TypographyProps = StyledTypographyProps & TextStyleProps;
export const TYPOGRAPHY = compose(typography, textStyle);

// These are 1:1 with styled-systems API.
export type FlexProps = FlexboxProps;

export type LayoutProps = StyledLayoutProps;

type TextStyleProps = { textStyle?: TextStyles };

export { flexbox as FLEX, layout as LAYOUT } from 'styled-system';
